





















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Ref, Mixins, Watch } from "vue-property-decorator";
import PrefillMixin from "@/mixins/PrefillMixin";
import PrefillReviewList, {
  PrefillReviewItem
} from "@/components/prefill/PrefillReviewList.vue";
import FormPrefillService from "@/services/FormPrefillService";
import moment from "moment";
import AsesmenAwalRanapKeperawatan from "@/services/AsesmenAwalRanapKeperawatan";
import http from "@/axios/http-common";
import AsesmenAwalRanapKeperawatanStore from "@/store/modules/AsesmenAwalRanapKeperawatanStore";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { PPJA_ONLY_HINT } from "@/utility/AsuhanKeperawatanHelper";
import { confirmRemove } from "@/utility/CommonHelper";
import TandaVital from "@/components/AsesmenAwalGadar/TandaVital.vue";
import Antropometri from "@/components/AsesmenAwalGadar/Antropometri.vue";
import CardPemeriksaanFisikDewasa from "./CardPemeriksaanFisikDewasa.vue";
import CardRiwayatPenyakitTerdahulu from "@/components/pemeriksaan/rpd/CardRiwayatPenyakitTerdahulu.vue";
import storeRefAsesmen, { Category } from "@/store/modules/new/ReferensiAsesmen";
import IndikatorNyeri from "@/components/nyeri/IndikatorNyeri.vue";
import {
  bandNyeri,
  judulBandNyeri,
  warnaBandNyeri
} from "@/utils/nyeriIntervensi";
import { TTV } from "@/types/asesmen";
import { PemeriksaanFisikRanap } from "@/types/pemeriksaan_fisik_ranap";

interface NyeriKomponen {
  ref_group_id: number;
  ref_group_title: string;
  ref_id: string | null;
  ref_title: string | null;
  skor: number | null;
}

const NYERI_METODE_KOMPONEN = ["FLACC", "NIPS", "BPS"];

const NYERI_KATALOG_KOSONG: Category[] = [];
const NYERI_OPSI_KOSONG: Category["val"] = [];

function defaultFisik(): PemeriksaanFisikRanap {
  return {
    penglihatan: { status: null, alat_bantu_ket: null, lainnya_ket: null },
    pendengaran: { status: null, alat_bantu_ket: null, lainnya_ket: null },
    penciuman: { status: null, alat_bantu_ket: null, lainnya_ket: null },
    gigi_mulut: { mulut: null, gigi: null, bibir: null },
    leher: { status: null, lainnya_ket: null },
    pernafasan: { suara_nafas: [], suara_lainnya_ket: null, irama: null, pola: null },
    kardiovaskuler: {
      irama: null,
      palpitasi: null,
      nyeri_dada: false,
      diaporesis: false,
      akral: null,
      crt: null,
      cyanosis: null,
      clubing: null,
      edema: false,
      edema_ket: null
    },
    pencernaan: {
      gejala: [],
      peristaltik: null,
      peristaltik_freq: null,
      tambahan: [],
      nyeri_ket: null,
      bab: [],
      diare_freq: null,
      diare_konsistensi: null,
      keluhan_lain: null
    },
    muskuloskeletal: {
      items: [],
      nyeri_sendi_ket: null,
      close_fraktur_ket: null,
      open_fraktur_ket: null,
      luksasio_ket: null,
      memar_ket: null,
      luka_ket: null,
      luka_bakar_ket: null,
      abses_ket: null,
      lainnya_ket: null
    },
    persyarafan: {
      pupil: null,
      pupil_ukuran: null,
      reflek_kanan: null,
      reflek_kiri: null,
      komunikasi: null,
      ekstremitas: [],
      kesemutan_ket: null,
      parese_ket: null,
      plegi_ket: null,
      kejang_ket: null,
      kekuatan_otot_ket: null,
      lainnya: null
    },
    seksualitas: {
      mamae: null,
      mamae_ket: null,
      hamil: null,
      hamil_g: null,
      hamil_p: null,
      hamil_a: null,
      usia_kehamilan: null,
      perineal: null,
      perineal_ket: null,
      gangguan_seksual: null
    },
    integumen: { warna: null, turgor: null, kulit: [], kulit_lainnya_ket: null },
    perkemihan: { items: [], lainnya_ket: null }
  };
}

function defaultContent() {
  return {
    sumber_data: [] as string[],
    hambatan_komunikasi: null,
    keluhan_utama: null,
    riwayat: {
      rps: null,
      rpd: null,
      rpk: null,
      sosial_rokok: null,
      sosial_rokok_ket: null,
      sosial_alkohol: null,
      sosial_alkohol_ket: null,
      sosial_napza: null,
      sosial_napza_ket: null
    },
    alergi: { status: "tidak", detail: null },
    rekonsiliasi_obat: { status: "tidak", daftar: [] },
    keadaan_umum: null,
    kesadaran: null,
    gcs: { e: null, v: null, m: null },
    tanda_vital: {
      sistole: null,
      diastole: null,
      nadi: null,
      nafas: null,
      suhu: null,
      saturasi_oksigen: null
    },
    antropometri: { bb: null, tb: null },
    nyeri: {
      ada: false,
      skala_method: "NRS",
      skor: null,
      interpretasi: null,
      komponen: [] as NyeriKomponen[],
      jenis: null,
      p: null,
      q: null,
      r: null,
      t: null
    },
    psikologis: {
      status: null as string | null,
      kecenderungan_bunuh_diri: false,
      masalah_perilaku: false,
      masalah_perilaku_ket: null
    },
    sosial: { hubungan_keluarga: null, tempat_tinggal: null },
    spiritual: {
      ibadah: null,
      ibadah_alasan: null,
      nilai_kepercayaan: null,
      keyakinan_sembuh: null
    },
    fisik: defaultFisik(),
    barthel: {
      makan: null,
      mandi: null,
      hygiene: null,
      berpakaian: null,
      bab: null,
      bak: null,
      toilet: null,
      transfer: null,
      mobilitas: null,
      tangga: null
    },
    morse: {
      riwayat_jatuh: null,
      dx_sekunder: null,
      alat_bantu: null,
      terapi_iv: null,
      gaya_jalan: null,
      status_mental: null
    },
    braden: {
      sensori: null,
      kelembapan: null,
      aktivitas: null,
      mobilitas: null,
      nutrisi: null,
      gesekan: null
    },
    gizi_mst: {
      skor_bb: null,
      skor_asupan: null,
      diagnosa_khusus_ada: null,
      diagnosa_khusus: [],
      diagnosa_khusus_lain: null,
      dilapor_gizi: null,
      dilapor_gizi_at: null
    },
    discharge: {
      tinggal_bersama: null,
      alat_bantu: null,
      diet_khusus: null,
      perawatan_lanjutan: null,
      rujukan_komunitas: null,
      wc_jenis: null
    },
    edukasi: {
      topik: null,
      kognitif: null,
      motivasi: null,
      keterbatasan_fisik: null,
      penerjemah: null
    },
    masalah_keperawatan: [""]
  };
}

@Component({
  components: {
    TandaVital,
    Antropometri,
    CardPemeriksaanFisikDewasa,
    CardRiwayatPenyakitTerdahulu,
    PrefillReviewList,
    IndikatorNyeri
  },
  inject: {
    isReadOnly: { default: () => () => false },
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class AsesmenRanapKeperawatanPage extends Mixins(PrefillMixin) {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;
  @Prop({ default: false }) readonly isActive!: boolean;
  @Ref() readonly dateTimePicker;
  isReadOnly!: () => boolean;
  verifikasiTerkunciFn!: () => boolean;

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  prefillFormKey = "asesmen_awal_ranap_keperawatan";

  prefillResolvePath(path: string) {
    if (path === "content.alergi.detail") {
      return {
        get: () => this.content.alergi.detail,
        set: (v) => {
          this.content.alergi.detail = v;
          this.content.alergi.status = "ada";
        }
      };
    }
    if (path.indexOf("content.") === 0 && path.indexOf("_list") === -1) {
      const segments = path.split(".").slice(1);
      const last = segments.pop() as string;
      const parent = segments.reduce((acc: any, seg) => (acc == null ? acc : acc[seg]), this.content);
      if (parent && Object.prototype.hasOwnProperty.call(parent, last)) {
        return {
          get: () => parent[last],
          set: (v) => {
            parent[last] = v;
          }
        };
      }
    }
    return { get: () => "__skip__", set: () => undefined };
  }

  get prefillObatKronikList(): PrefillReviewItem[] {
    const p = this.prefillPayload;
    return p && p.fields ? p.fields["riwayat.obat_kronik_list"] || [] : [];
  }

  applyObatKronik(items: PrefillReviewItem[]) {
    items.forEach(it => {
      this.content.rekonsiliasi_obat.daftar.push({
        nama: it.nama_obat || it.value,
        dosis: it.dosis_text || null,
        frekuensi: it.jadwal_text || null,
        rute: it.rute_text || null
      });
    });
    this.content.rekonsiliasi_obat.status = "menggunakan";
    this.logPrefillPartial("riwayat.obat_kronik_list");
  }

  logPrefillPartial(listPath: string) {
    FormPrefillService.logAcceptance({
      form_key: this.prefillFormKey,
      pasien_rm: String(this.rm),
      register_id: this.register,
      unit_id: this.stateUser ? this.stateUser.unit_id : null,
      event: "partial",
      fields: [listPath],
      provenance: {},
      sources: this.prefillPayload ? this.prefillPayload.sources : []
    });
  }

  saving = false;
  removing = false;
  asesmenId = null;
  examinedAt = null;
  verifyingPpja = false;
  verifyingDpjp = false;
  rmeDxMenu = false;
  loadingRmeDx = false;
  rmeDiagnoses: any[] = [];

  hydratingNyeri = false;

  content: ReturnType<typeof defaultContent> = defaultContent();

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

  sumberDataItems = [
    "Pasien",
    "Keluarga",
    "Rekam medis lama",
    "Rujukan FKTP",
    "Tidak dapat dikaji"
  ];
  keadaanUmumItems = [
    "Baik",
    "Tampak sakit ringan",
    "Tampak sakit sedang",
    "Tampak sakit berat"
  ];
  kesadaranItems = [
    "Composmentis",
    "Apatis",
    "Delirium",
    "Somnolen",
    "Sopor",
    "Semi Coma",
    "Coma"
  ];
  nyeriRangeSkala = ["0", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  nyeriSelectProps = { openOnHover: true, offsetY: true };
  statusEmosiItems = ["Tenang", "Cemas", "Takut", "Marah", "Sedih"];
  tempatTinggalItems = [
    "Rumah sendiri",
    "Rumah keluarga",
    "Sewa/kontrak",
    "Panti",
    "Lainnya"
  ];

  barthelFields = [
    { key: "makan", label: "Makan", options: [{ text: "Tidak mampu (0)", value: 0 }, { text: "Butuh bantuan (5)", value: 5 }, { text: "Mandiri (10)", value: 10 }] },
    { key: "mandi", label: "Mandi", options: [{ text: "Tergantung (0)", value: 0 }, { text: "Mandiri (5)", value: 5 }] },
    { key: "hygiene", label: "Personal Hygiene", options: [{ text: "Tergantung (0)", value: 0 }, { text: "Mandiri (5)", value: 5 }] },
    { key: "berpakaian", label: "Berpakaian", options: [{ text: "Tergantung (0)", value: 0 }, { text: "Butuh bantuan (5)", value: 5 }, { text: "Mandiri (10)", value: 10 }] },
    { key: "bab", label: "BAB", options: [{ text: "Inkontinensia (0)", value: 0 }, { text: "Kadang (5)", value: 5 }, { text: "Kontinen (10)", value: 10 }] },
    { key: "bak", label: "BAK", options: [{ text: "Inkontinensia (0)", value: 0 }, { text: "Kadang (5)", value: 5 }, { text: "Kontinen (10)", value: 10 }] },
    { key: "toilet", label: "Penggunaan Toilet", options: [{ text: "Tergantung (0)", value: 0 }, { text: "Butuh bantuan (5)", value: 5 }, { text: "Mandiri (10)", value: 10 }] },
    { key: "transfer", label: "Transfer Kursi-Tempat Tidur", options: [{ text: "Tidak mampu (0)", value: 0 }, { text: "Bantuan banyak (5)", value: 5 }, { text: "Bantuan sedikit (10)", value: 10 }, { text: "Mandiri (15)", value: 15 }] },
    { key: "mobilitas", label: "Mobilitas", options: [{ text: "Imobil (0)", value: 0 }, { text: "Kursi roda mandiri (5)", value: 5 }, { text: "Berjalan dibantu (10)", value: 10 }, { text: "Mandiri (15)", value: 15 }] },
    { key: "tangga", label: "Naik-Turun Tangga", options: [{ text: "Tidak mampu (0)", value: 0 }, { text: "Butuh bantuan (5)", value: 5 }, { text: "Mandiri (10)", value: 10 }] }
  ];

  morseFields = [
    { key: "riwayat_jatuh", label: "Riwayat jatuh (3 bln terakhir)", options: [{ text: "Tidak (0)", value: 0 }, { text: "Ya (25)", value: 25 }] },
    { key: "dx_sekunder", label: "Diagnosis sekunder (≥1)", options: [{ text: "Tidak (0)", value: 0 }, { text: "Ya (15)", value: 15 }] },
    { key: "alat_bantu", label: "Alat bantu", options: [{ text: "Tidak ada/bed rest/perawat (0)", value: 0 }, { text: "Kruk/tongkat/walker (15)", value: 15 }, { text: "Furniture (30)", value: 30 }] },
    { key: "terapi_iv", label: "Terapi IV / heparin lock", options: [{ text: "Tidak (0)", value: 0 }, { text: "Ya (20)", value: 20 }] },
    { key: "gaya_jalan", label: "Gaya berjalan", options: [{ text: "Normal/bed rest (0)", value: 0 }, { text: "Lemah (10)", value: 10 }, { text: "Terganggu (20)", value: 20 }] },
    { key: "status_mental", label: "Status mental", options: [{ text: "Sadar keterbatasan (0)", value: 0 }, { text: "Tidak sadar (15)", value: 15 }] }
  ];

  bradenFields = [
    { key: "sensori", label: "Persepsi Sensori", options: [{ text: "1 - Terbatas penuh", value: 1 }, { text: "2 - Sangat terbatas", value: 2 }, { text: "3 - Sedikit terbatas", value: 3 }, { text: "4 - Tidak terganggu", value: 4 }] },
    { key: "kelembapan", label: "Kelembapan", options: [{ text: "1 - Konstan lembap", value: 1 }, { text: "2 - Sangat lembap", value: 2 }, { text: "3 - Kadang lembap", value: 3 }, { text: "4 - Jarang lembap", value: 4 }] },
    { key: "aktivitas", label: "Aktivitas", options: [{ text: "1 - Bed-fast", value: 1 }, { text: "2 - Chair-fast", value: 2 }, { text: "3 - Jalan kadang", value: 3 }, { text: "4 - Jalan teratur", value: 4 }] },
    { key: "mobilitas", label: "Mobilitas", options: [{ text: "1 - Imobil total", value: 1 }, { text: "2 - Sangat terbatas", value: 2 }, { text: "3 - Sedikit terbatas", value: 3 }, { text: "4 - Tidak terbatas", value: 4 }] },
    { key: "nutrisi", label: "Nutrisi", options: [{ text: "1 - Sangat buruk", value: 1 }, { text: "2 - Kurang adekuat", value: 2 }, { text: "3 - Adekuat", value: 3 }, { text: "4 - Sangat baik", value: 4 }] },
    { key: "gesekan", label: "Gesekan & Geseran", options: [{ text: "1 - Bermasalah", value: 1 }, { text: "2 - Potensi bermasalah", value: 2 }, { text: "3 - Tidak bermasalah", value: 3 }] }
  ];

  mstBbOptions = [
    { text: "Tidak ada penurunan (0)", value: 0 },
    { text: "Tidak yakin / baju longgar (2)", value: 2 },
    { text: "1–5 kg (1)", value: 1 },
    { text: "6–10 kg (2)", value: 2 },
    { text: "11–15 kg (3)", value: 3 },
    { text: ">15 kg (4)", value: 4 }
  ];
  mstAsupanOptions = [
    { text: "Tidak (0)", value: 0 },
    { text: "Ya (1)", value: 1 }
  ];
  mstDiagnosaKhususOptions = ["DM", "Ginjal", "Hati", "Jantung", "Paru", "Stroke", "Kanker", "Penurunan Imunitas", "Geriatri"];

  get readOnly(): boolean {
    return this.isReadOnly() || (this.isVerified && !this.canUpdateSigned);
  }

  get canUpdateSigned(): boolean {
    return userModule.hasPrivilege("asesmen_awal_ranap_keperawatan", "update_signed");
  }

  get canWrite(): boolean {
    return !this.readOnly;
  }

  get asesmenRaw(): any {
    return AsesmenAwalRanapKeperawatanStore.asesmen || {};
  }

  get canVerifyAsesmenKeperawatan(): boolean {
    return userModule.canVerifyAsesmenKeperawatan;
  }

  get ppjaOnlyHint(): string {
    return PPJA_ONLY_HINT;
  }

  get ppjaVerified(): boolean {
    return !!this.asesmenRaw.ppja_verified_at;
  }

  get dpjpVerified(): boolean {
    return !!this.asesmenRaw.dpjp_verified_at;
  }

  get isVerified(): boolean {
    return this.ppjaVerified || this.dpjpVerified;
  }

  get stateUser() {
    return userModule.user;
  }

  get perawatNama() {
    if (this.asesmenRaw.perawat?.nama) return this.asesmenRaw.perawat.nama;
    if (this.asesmenId) return "-";
    const u: any = this.stateUser;
    return u?.nama || u?.name || u?.username || "-";
  }

  get isPengkajiAwal(): boolean {
    if (!this.asesmenId) return true;
    return Number(this.asesmenRaw.perawat_user_id) === Number((this.stateUser as any)?.id);
  }

  get perawatPengkajiHint(): string {
    if (!this.asesmenId) return "Diisi otomatis dari akun yang login";
    if (this.isPengkajiAwal) return "Perawat yang pertama mengkaji pasien ini";
    return `Anda melengkapi asesmen yang dikaji ${this.perawatNama} — nama pengkaji awal tidak berubah`;
  }

  get gcsTotal() {
    const { e, v, m } = this.content.gcs;
    return (e || 0) + (v || 0) + (m || 0);
  }

  get gcsComplete(): boolean {
    const { e, v, m } = this.content.gcs;
    return !!(e && v && m);
  }

  get kesadaranFromGcs(): string | null {
    if (!this.gcsComplete) return null;
    const t = this.gcsTotal;
    if (t >= 14) return "Composmentis";
    if (t >= 12) return "Apatis";
    if (t >= 10) return "Delirium";
    if (t >= 7) return "Somnolen";
    if (t >= 5) return "Sopor";
    if (t === 4) return "Semi Coma";
    return "Coma";
  }

  @Watch("kesadaranFromGcs")
  applyKesadaranFromGcs(val: string | null) {
    if (this.readOnly || !val) return;
    if (this.content.kesadaran !== val) this.content.kesadaran = val;
  }

  get valTtv(): TTV {
    const tv = this.content.tanda_vital;
    return {
      sistole: tv.sistole,
      diastole: tv.diastole,
      nadi: tv.nadi,
      nafas: tv.nafas,
      suhu: tv.suhu,
      saturasiO2: tv.saturasi_oksigen
    } as TTV;
  }

  set valTtv(val: TTV) {
    this.content.tanda_vital.sistole = val.sistole;
    this.content.tanda_vital.diastole = val.diastole;
    this.content.tanda_vital.nadi = val.nadi;
    this.content.tanda_vital.nafas = val.nafas;
    this.content.tanda_vital.suhu = val.suhu;
    this.content.tanda_vital.saturasi_oksigen = val.saturasiO2;
  }

  get antropometriValues() {
    return { bb: this.content.antropometri.bb, tb: this.content.antropometri.tb };
  }

  get imt() {
    const bb = parseFloat(this.content.antropometri.bb as any);
    const tb = parseFloat(this.content.antropometri.tb as any);
    if (!bb || !tb) return null;
    return (bb / Math.pow(tb / 100, 2)).toFixed(1);
  }

  get nyeriBand() {
    return bandNyeri(this.content.nyeri.skala_method, this.content.nyeri.skor);
  }
  get nyeriInterpretasi() {
    return judulBandNyeri(this.nyeriBand);
  }
  get nyeriColor() {
    return warnaBandNyeri(this.nyeriBand);
  }

  get nyeriMethodItems(): string[] {
    const base = ["NRS", ...NYERI_METODE_KOMPONEN];
    const cur = this.content.nyeri.skala_method;
    return cur && base.indexOf(cur) === -1 ? [...base, cur] : base;
  }

  get nyeriMethodKeterangan(): string {
    switch (this.content.nyeri.skala_method) {
      case "NRS":
        return "Untuk dewasa dan anak > 3 tahun yang mampu melaporkan nyeri secara verbal.";
      case "FLACC":
        return "Untuk pasien yang tidak kooperatif / tersedasi.";
      case "NIPS":
        return "Untuk neonatus 0–28 hari.";
      case "BPS":
        return "Untuk pasien perawatan intensif / terintubasi.";
      default:
        return "Instrumen lama — tetap ditampilkan agar isi record tidak berubah.";
    }
  }

  get nyeriPakaiKomponen(): boolean {
    return NYERI_METODE_KOMPONEN.indexOf(this.content.nyeri.skala_method) !== -1;
  }

  get nyeriKomponenAktif(): Category[] {
    switch (this.content.nyeri.skala_method) {
      case "FLACC":
        return storeRefAsesmen.nyeriFLACC;
      case "NIPS":
        return storeRefAsesmen.nyeriNIPS;
      case "BPS":
        return storeRefAsesmen.nyeriBPS;
      default:
        return NYERI_KATALOG_KOSONG;
    }
  }

  nyeriOpsiKomponen(refGroupId: number) {
    const cat = this.nyeriKomponenAktif.find(
      c => Number(c.id) === Number(refGroupId)
    );
    return cat ? cat.val : NYERI_OPSI_KOSONG;
  }

  get nyeriTotalKomponen(): number | null {
    if (!this.nyeriKomponenLengkap) return null;
    return (this.content.nyeri.komponen as NyeriKomponen[]).reduce(
      (sum, i) => sum + (i.skor || 0),
      0
    );
  }

  get nyeriKomponenLengkap(): boolean {
    const items = this.content.nyeri.komponen as NyeriKomponen[];
    return items.length > 0 && items.every(i => i.skor != null);
  }

  buildNyeriKomponen(sebelumnya: NyeriKomponen[] = []): NyeriKomponen[] {
    return this.nyeriKomponenAktif.map(cat => {
      const lama = (sebelumnya || []).find(
        k => k && Number(k.ref_group_id) === Number(cat.id)
      );
      return {
        ref_group_id: cat.id,
        ref_group_title: cat.title,
        ref_id: lama ? lama.ref_id : null,
        ref_title: lama ? lama.ref_title : null,
        skor: lama && lama.skor != null ? Number(lama.skor) : null
      };
    });
  }

  setNyeriKomponen(idx: number, refId: string | null) {
    const row = (this.content.nyeri.komponen as NyeriKomponen[])[idx];
    if (!row) return;
    const opsi = this.nyeriOpsiKomponen(row.ref_group_id).find(
      o => String(o.id) === String(refId)
    );
    row.ref_id = opsi ? opsi.id : null;
    row.ref_title = opsi ? opsi.title : null;
    row.skor = opsi ? Number(opsi.scoring) : null;
    this.content.nyeri.skor = this.nyeriTotalKomponen;
  }

  @Watch("content.nyeri.ada")
  onNyeriAdaChange(val: boolean) {
    if (this.hydratingNyeri) return;
    if (!val) {
      this.content.nyeri.skor = null;
      this.content.nyeri.komponen = [];
    } else {
      this.syncNyeriKomponen(true);
      this.seedSkorNrs();
    }
  }

  @Watch("content.nyeri.skala_method")
  onNyeriMethodChange(val: string, oldVal: string) {
    if (this.hydratingNyeri || val === oldVal) return;
    this.content.nyeri.skor = null;
    this.syncNyeriKomponen(true);
    this.seedSkorNrs();
  }

  seedSkorNrs() {
    if (this.nyeriPakaiKomponen) return;
    if (this.content.nyeri.skor == null) this.content.nyeri.skor = 0;
  }

  syncNyeriKomponen(reset = false) {
    if (!this.nyeriPakaiKomponen) {
      this.content.nyeri.komponen = [];
      return;
    }
    if (!this.nyeriKomponenAktif.length) return;
    const lama = reset ? [] : (this.content.nyeri.komponen as NyeriKomponen[]);
    this.content.nyeri.komponen = this.buildNyeriKomponen(lama);
  }

  @Watch("nyeriKomponenAktif")
  onNyeriKatalogReady() {
    if (!this.content.nyeri.ada || !this.nyeriPakaiKomponen) return;
    if ((this.content.nyeri.komponen as NyeriKomponen[]).length) return;
    this.syncNyeriKomponen(false);
  }

  get barthelTotal() {
    const b = this.content.barthel as Record<string, number>;
    return this.barthelFields.reduce((sum, f) => sum + (b[f.key] || 0), 0);
  }
  get barthelInterpretasi() {
    const t = this.barthelTotal;
    if (t === 100) return "Mandiri";
    if (t >= 91) return "Ketergantungan Ringan";
    if (t >= 61) return "Ketergantungan Sedang";
    if (t >= 21) return "Ketergantungan Berat";
    return "Ketergantungan Total";
  }
  get barthelColor() {
    const t = this.barthelTotal;
    if (t === 100) return "green";
    if (t >= 61) return "amber darken-2";
    return "red";
  }

  get morseTerisi(): boolean {
    const m = this.content.morse as Record<string, number>;
    return this.morseFields.some(f => m[f.key] != null);
  }
  get morseTotal() {
    if (!this.morseTerisi) return 0;
    const m = this.content.morse as Record<string, number>;
    return this.morseFields.reduce((sum, f) => sum + (m[f.key] || 0), 0);
  }
  get morseInterpretasi() {
    if (!this.morseTerisi) return "-";
    const t = this.morseTotal;
    if (t >= 51) return "Risiko Tinggi";
    if (t >= 25) return "Risiko Rendah";
    return "Tidak Berisiko";
  }
  get morseColor() {
    if (!this.morseTerisi) return "grey";
    const t = this.morseTotal;
    if (t >= 51) return "red";
    if (t >= 25) return "amber darken-2";
    return "green";
  }

  get bradenTotal() {
    const b = this.content.braden as Record<string, number>;
    const anyFilled = this.bradenFields.some(f => b[f.key] != null);
    if (!anyFilled) return 0;
    return this.bradenFields.reduce((sum, f) => sum + (b[f.key] || 0), 0);
  }
  get bradenInterpretasi() {
    const t = this.bradenTotal;
    if (t === 0) return "-";
    if (t >= 19) return "Risiko Rendah";
    if (t >= 15) return "Risiko Ringan";
    if (t >= 13) return "Risiko Sedang";
    if (t >= 10) return "Risiko Tinggi";
    return "Risiko Sangat Tinggi";
  }
  get bradenColor() {
    const t = this.bradenTotal;
    if (t === 0) return "grey";
    if (t >= 19) return "green";
    if (t >= 15) return "amber darken-2";
    return "red";
  }

  get mstTotal() {
    return (this.content.gizi_mst.skor_bb || 0) + (this.content.gizi_mst.skor_asupan || 0);
  }
  get mstInterpretasi() {
    return this.mstTotal >= 2 ? "Berisiko Malnutrisi" : "Risiko Rendah";
  }
  get mstPerluKonsulGizi() {
    return this.mstTotal >= 2 || this.content.gizi_mst.diagnosa_khusus_ada === "ya";
  }

  get formatedExaminedAt() {
    return this.examinedAt
      ? moment(this.examinedAt).format("YYYY-MM-DD HH:mm:ss")
      : moment().format("YYYY-MM-DD HH:mm:ss");
  }

  get requestParams() {
    return {
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: this.stateUser.unit_id,
      type: "dewasa",
      version: "1.0.0",
      examined_at: this.formatedExaminedAt,
      perawat_user_id: this.stateUser.id,
      content: {
        ...this.content,
        gcs: { ...this.content.gcs, total: this.gcsTotal },
        antropometri: { ...this.content.antropometri, imt: this.imt },
        nyeri: {
          ...this.content.nyeri,
          skor: this.content.nyeri.ada ? this.content.nyeri.skor : null,
          interpretasi: this.content.nyeri.ada ? this.nyeriInterpretasi : null,
          komponen: this.content.nyeri.ada && this.nyeriPakaiKomponen
            ? this.content.nyeri.komponen
            : []
        },
        barthel: { ...this.content.barthel, total: this.barthelTotal, interpretasi: this.barthelInterpretasi },
        morse: { ...this.content.morse, total: this.morseTotal, interpretasi: this.morseInterpretasi },
        braden: { ...this.content.braden, total: this.bradenTotal, interpretasi: this.bradenInterpretasi },
        gizi_mst: { ...this.content.gizi_mst, total: this.mstTotal, interpretasi: this.mstInterpretasi, perlu_konsul_gizi: this.mstPerluKonsulGizi }
      }
    };
  }

  mounted() {
    this.loadKatalogNyeri();
    this.getByRegister();
  }

  loadKatalogNyeri() {
    if (!storeRefAsesmen.nyeriFLACC.length) storeRefAsesmen.getNyeriFLACC();
    if (!storeRefAsesmen.nyeriNIPS.length) storeRefAsesmen.getNyeriNIPS();
    if (!storeRefAsesmen.nyeriBPS.length) storeRefAsesmen.getNyeriBPS();
  }

  setTtv(val: TTV) {
    this.valTtv = val;
  }

  setAntropometri(val) {
    this.content.antropometri.bb = val.bb;
    this.content.antropometri.tb = val.tb;
  }

  normalizeFisik(saved: any): PemeriksaanFisikRanap {
    const def: any = defaultFisik();
    const src: any = saved && typeof saved === "object" ? saved : {};
    const out: any = {};
    Object.keys(def).forEach(section => {
      const savedSection =
        src[section] && typeof src[section] === "object" ? src[section] : {};
      out[section] = { ...def[section], ...savedSection };
    });
    return out as PemeriksaanFisikRanap;
  }

  ruteSediaanOptions = ["Oral", "Cream", "Salep"];

  addObat() {
    this.content.rekonsiliasi_obat.daftar.push({ nama: "", dosis: "", frekuensi: "", rute: "" } as any);
  }
  removeObat(i: number) {
    this.content.rekonsiliasi_obat.daftar.splice(i, 1);
  }
  addMasalah() {
    this.content.masalah_keperawatan.push("");
  }

  async loadRmeDiagnoses() {
    if (this.loadingRmeDx || !this.register) return;
    this.loadingRmeDx = true;
    try {
      const resp = await http.getData(`/register/${this.register}/diagnosis-icd`);
      const data = resp?.data?.data;
      this.rmeDiagnoses = Array.isArray(data) ? data : [];
    } catch {
      this.rmeDiagnoses = [];
    } finally {
      this.loadingRmeDx = false;
    }
  }

  addMasalahFromDx(dx: any) {
    const label = [dx.kode, dx.nama].filter(Boolean).join(" - ");
    if (!label) return;
    if (this.content.masalah_keperawatan.includes(label)) return;
    const emptyIdx = this.content.masalah_keperawatan.findIndex(m => !m || !m.trim());
    if (emptyIdx !== -1) {
      this.$set(this.content.masalah_keperawatan, emptyIdx, label);
    } else {
      this.content.masalah_keperawatan.push(label);
    }
  }
  removeMasalah(i: number) {
    this.content.masalah_keperawatan.splice(i, 1);
  }

  save() {
    if (this.saving) return;
    this.saving = true;

    const existing = AsesmenAwalRanapKeperawatanStore.asesmen;
    const sendRequest = existing
      ? AsesmenAwalRanapKeperawatan.update(existing.id, this.requestParams)
      : AsesmenAwalRanapKeperawatan.create(this.requestParams);

    sendRequest
      .then(() => {
        appModule.NoticeDelay("Berhasil Simpan Asesmen Keperawatan");
        this.getByRegister();
      })
      .finally(() => {
        this.saving = false;
      });
  }

  async getByRegister() {
    await AsesmenAwalRanapKeperawatanStore.getByRegister(this.register);

    const data = AsesmenAwalRanapKeperawatanStore.asesmen;

    if (data) {
      this.asesmenId = data.id;
      this.examinedAt = data.examined_at ? new Date(data.examined_at) : null;
      const saved = (data.content as any) || {};
      this.hydratingNyeri = true;
      this.content = { ...defaultContent(), ...saved };
      this.content.riwayat = { ...defaultContent().riwayat, ...(saved.riwayat || {}) };
      this.content.discharge = { ...defaultContent().discharge, ...(saved.discharge || {}) };
      this.content.gizi_mst = { ...defaultContent().gizi_mst, ...(saved.gizi_mst || {}) };
      this.content.nyeri = { ...defaultContent().nyeri, ...(saved.nyeri || {}) };
      this.normalizeNyeri();
      this.content.fisik = this.normalizeFisik(this.content.fisik);
      if (typeof this.content.sumber_data === "string") {
        this.content.sumber_data = [this.content.sumber_data] as any;
      } else if (!Array.isArray(this.content.sumber_data)) {
        this.content.sumber_data = [] as any;
      }
      const emosiTersimpan: unknown = this.content.psikologis.status;
      if (Array.isArray(emosiTersimpan)) {
        this.content.psikologis.status = emosiTersimpan.length ? String(emosiTersimpan[0]) : null;
      }
      if (!this.content.masalah_keperawatan || !this.content.masalah_keperawatan.length) {
        this.content.masalah_keperawatan = [""];
      }
      this.applyKesadaranFromGcs(this.kesadaranFromGcs);
      this.$nextTick(() => {
        this.hydratingNyeri = false;
      });
    } else {
      this.clearInput();
      if (!this.readOnly) {
        this.$nextTick(() => {
          this.loadPrefill({
            pasien_rm: String(this.rm),
            register_id: this.register,
            unit_id: this.stateUser ? this.stateUser.unit_id : undefined
          });
        });
      }
    }
  }

  remove() {
    if (this.removing) return;
    const confirmed = confirmRemove("Asesmen Awal Keperawatan Ranap Dewasa");
    if (!confirmed) return;

    this.removing = true;
    AsesmenAwalRanapKeperawatan.destroy(this.asesmenId)
      .then(() => {
        appModule.NoticeDelay("Berhasil Hapus Asesmen Keperawatan");
        this.getByRegister();
      })
      .finally(() => {
        this.removing = false;
      });
  }

  normalizeNyeri() {
    const n = this.content.nyeri;
    if (!Array.isArray(n.komponen)) n.komponen = [];
    if (!this.nyeriPakaiKomponen) {
      n.komponen = [];
      return;
    }
    if (!this.nyeriKomponenAktif.length) return;
    n.komponen = this.buildNyeriKomponen(n.komponen);
  }

  clearInput() {
    this.asesmenId = null;
    this.hydratingNyeri = true;
    this.content = defaultContent();
    this.$nextTick(() => {
      this.hydratingNyeri = false;
    });
  }

  cetak() {
    if (!this.asesmenId) return;
    AsesmenAwalRanapKeperawatan.print(this.asesmenId);
  }

  async verifyPpja() {
    const userId = this.stateUser && this.stateUser.id;
    if (!userId || !this.asesmenId || this.verifikasiTerkunci) return;
    this.verifyingPpja = true;
    try {
      await AsesmenAwalRanapKeperawatan.verifyPpja(this.asesmenId, userId);
      appModule.NoticeDelay("Asesmen terverifikasi oleh PPJA");
      await this.getByRegister();
    } finally {
      this.verifyingPpja = false;
    }
  }

  async verifyDpjp() {
    const userId = this.stateUser && this.stateUser.id;
    if (!userId || !this.asesmenId || this.verifikasiTerkunci) return;
    this.verifyingDpjp = true;
    try {
      await AsesmenAwalRanapKeperawatan.verifyDpjp(this.asesmenId, userId);
      appModule.NoticeDelay("Asesmen terverifikasi oleh DPJP");
      await this.getByRegister();
    } finally {
      this.verifyingDpjp = false;
    }
  }
}
